import * as React from 'react';
import { AccordionItemContext, } from '../accordion-item/accordion-item-context';
export default class AccordionContent extends React.Component {
    render() {
        return (React.createElement("div", { className: "accordion__body", style: this.context.collapseStyle, ref: this.context.accordionRef },
            React.createElement("div", { className: "accordion__content", id: this.context.id }, this.props.children)));
    }
}
AccordionContent.contextType = AccordionItemContext;
